import {FC} from 'react';
import TaskRowStart from './TaskRowStart';
import TaskRenderer from './TaskRenderer';
import TaskRowEnd from './TaskRowEnd';

type TaskRowProps = {
  enableTransform: () => void,
  disableTransform: () => void,
  zoomToElement: (id: string, scale: number) => void
};

const TaskRow: FC<TaskRowProps> = ({
  enableTransform,
  disableTransform,
  zoomToElement
}) => (
  <div className="task-row-elements">
    <TaskRowStart />

    <TaskRenderer
      disableTransform={disableTransform}
      enableTransform={enableTransform}
      zoomToElement={zoomToElement}
    />

    <TaskRowEnd />
  </div>
);

export default TaskRow;
